const awsConfig = {
  awsIdentityPoolID:
    process.env.NEXT_PUBLIC_AWS_IDENTITY_POOL_ID ||
    'ap-southeast-1:386da2c2-e26d-433a-9445-e169c0a9f8c7',
  awsRegion: process.env.NEXT_PUBLIC_AWS_REGION || 'ap-southeast-1',
  awsMapName: process.env.NEXT_PUBLIC_AWS_MAP_NAME || 'GrabDemoMap',
  awsMapStyle: process.env.NEXT_PUBLIC_AWS_MAP_STYLE || 'VectorGrabMonoStreet',
  awsMapPlace: process.env.NEXT_PUBLIC_AWS_MAP_PLACE || 'GrabDemoPlaceIndex',
  awsMapGeofence: process.env.NEXT_PUBLIC_AWS_MAP_GEOFENCE || 'GrabDemoGeofenceCollection',
  awsMapTracker: process.env.NEXT_PUBLIC_AWS_MAP_TRACKER || 'GrabDemoTrackers',
  awsTrackerSimulatedDevice: process.env.NEXT_PUBLIC_AWS_TRACKER_SIMULATED_DEVICE || 'Vehicle-1',
};

const apiConfig = {
  apiGatewayURL: process.env.NEXT_PUBLIC_GATEWAY_URL,
  shipmentAPI:
    process.env.NEXT_PUBLIC_SHIPMENT_API || 'https://shipment-api.staging-k8s.jubelio.com',
};

const ssoConfig = {
  ssoUrl: process.env.NEXT_PUBLIC_SSO_URL || 'https://oauth-staging.jubelio.com',
  ssoAPI: process.env.NEXT_PUBLIC_SSO_API || 'https://oauth-service.staging-k8s.jubelio.com',
};

const defaultHost = ['azra-liquid.my.id', 'azra-collection.com', 'zee.jubelio.store'];

const featureWhitelistConfig = {
  allowHost: process.env.NEXT_PUBLIC_FEATURE_WHITELIST_HOST || defaultHost,
};

export const config = {
  appUrl:
    process.env.NODE_ENV === 'development'
      ? process.env.NEXT_PUBLIC_APP_URL_DEV
      : process.env.NEXT_PUBLIC_APP_URL || 'https://v2-stg.jubelio.store',
  ...awsConfig,
  ...ssoConfig,
  ...apiConfig,
  ...featureWhitelistConfig,
};
